import script from "./ShoppingCart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShoppingCart.vue?vue&type=script&setup=true&lang=ts"

import "./ShoppingCart.vue?vue&type=style&index=0&id=634bdf95&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634bdf95"]])

export default __exports__